var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".new-events img{\r\n  width: 85%;\r\n  height: auto;\r\n  -webkit-box-shadow: 0 0 8px 4px rgba(0,0,0,.3);\r\n  box-shadow: 0  0 0 8px 4px rgba(0,0,0,.3);\r\n}\r\n\r\n.new-events {\r\n  color: #f1f1f1;\r\n  text-align: center;\r\n}\r\n\r\n.new-events h2 {\r\n  font-weight: 600;\r\n}\r\n\r\n.new-events-bg {\r\n  background: url(" + escape(require("../../../../assets/img/news/event-bg.png")) + ");\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  background-position: center center;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/anach/Desktop/tengtu-website/src/app/components/home/news/news.component.css
// module id = ../../../../../src/app/components/home/news/news.component.css
// module chunks = main